import React from "react";
import TreeNode from "./TreeNode";

const TreeView = ({
  treeData = [],
  expandedNodes = {},
  onDragStart,
  onDrop,
  onToggle,
  onDeleteTopic,
  onDeleteIndicator,
  onDeleteCategory,
  onDeleteSubcategory,
  onAddCategory,
  onAddSubcategory,
  onAddIndicator,
  onEditIndicator,
  onEditNode,
}) => {
  if (!treeData || treeData.length === 0) {
    return (
      <div
        style={{
          padding: "16px",
          textAlign: "center",
          color: "#6b7280",
          fontStyle: "italic",
        }}
      >
        No portal data found.
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: "#f9fafb",
      }}
    >
      {treeData.map((node) => (
        <TreeNode
          key={node.id}
          node={node}
          level={0}
          onDragStart={onDragStart}
          onDrop={onDrop}
          onToggle={onToggle}
          expandedNodes={expandedNodes}
          onDeleteTopic={onDeleteTopic}
          onDeleteCategory={onDeleteCategory}
          onDeleteSubcategory={onDeleteSubcategory}
          onDeleteIndicator={onDeleteIndicator}
          onAddCategory={onAddCategory}
          onAddSubcategory={onAddSubcategory}
          onAddIndicator={onAddIndicator} 
          onEditIndicator={onEditIndicator}
         onEditNode={onEditNode}
        />
      ))}
    </div>
  );
};

export default TreeView;


